import React, { useEffect, useRef, useState } from 'react'
import ImageComponent from '../../../common/Image'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal';
import { getApplicationData } from '../../../../slices/dashboard/dashboardSlice';
import { getImeiDetails, setStage, setSubStage } from '../../../../slices/eligibility/eligibilitySlice';

function Screenbros({ application_id, brand, model, screenBrosScreen, serialNumber }) {

    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(0);
    const timerRef = useRef(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (!referenceId && !screenBrosScreen) return;

        let intervalId;

        const fetchApplicationData = async () => {
            try {
                const payload = { reference_id: referenceId };
                const response = await dispatch(getApplicationData(payload)).unwrap();

                if (response?.response_code === "S100") {

                    if (response.response_data?.screen_bros_validation === 'success') {
                        toast.success("Device setup completed successfully");
                        setShowSuccess(true);
                        // ✅ stop polling once esign is true
                        if (intervalId) clearInterval(intervalId);
                    } else {
                        setShowSuccess(false);
                    }
                } else {
                    !response?.payload?.error &&
                    toast.error(response?.response_string || "Failed to fetch application data");
                }
            } catch (error) {
                console.error("Error fetching application data:", error);
                toast.error("Failed to fetch application data");
            } finally {
            }
        };

        // initial call
        fetchApplicationData();

        // set up polling every 10 seconds
        intervalId = setInterval(fetchApplicationData, 60000);

        // cleanup on unmount
        return () => clearInterval(intervalId);
    }, [dispatch, referenceId]);

    const handleBackNavigation = (e) => {
        e.preventDefault();
        navigate('/dashboard');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate('/dashboard');
        }
    };

    const fetchApplicationData = async () => {
        try {
            const payload = { reference_id: referenceId };
            const response = await dispatch(getImeiDetails(payload)).unwrap();

            if (response?.response_code === "S100") {

                if (response.response_data?.screen_bros_validation === 'success') {
                    dispatch(setStage(response.response_data?.stage));
                    dispatch(setSubStage(response.response_data?.subStage));
                    toast.success("Device setup completed successfully");
                    setShowSuccess(true);
                }
                else if (response.response_data?.screen_bros_validation === 'in-progress') {
                    toast.error(`Device setup is in-progress`)
                    setShowSuccess(false);
                } else {
                    setShowSuccess(false);
                }
            } else {
                !response?.payload?.error &&
                toast.error(response?.response_string || "Failed to fetch application data");
            }
        } catch (error) {
            console.error("Error fetching application data:", error);
            toast.error("Failed to fetch application data");
        } finally {
        }
    };

    const handleRetrieveClick = () => {
        setIsDisabled(true);
        setSecondsLeft(30);
        fetchApplicationData();
        timerRef.current = setInterval(() => {
            setSecondsLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    setIsDisabled(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    return (
        <>
            <div className="position-relative ">
                <header className="sticky-top rounded-0 screenbros-header">
                    <div className="container-fluid topNav-dash">
                        <div className="web-header">
                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                                <div className="d-flex align-items-center tablet-content">
                                    <a href="Dashboard.html">
                                        <ImageComponent fileName="cd-cholalogo.svg" className="img-fluid logo-height" alt="logo" />
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="mob-header">
                            <div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="text-white fs-6 d-flex py-2 mt-2 align-items-center gap-1">
                                        <span className="icon-arrowleftl1 fs-2" onClick={handleBackNavigation}
                                            onKeyDown={handleKeyDown}
                                            tabIndex="0"
                                            role="button"></span> Device Enrollment
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            <div className="container-fluid kyc-tab-dash-app height-scroll screen-bros-dash screen-bros-lightbox">
                <div className="row gy-3 screenbro">
                    <div className="col-md-12 col-sm-12 text-center">
                        <p className="fw-semibold m-0 text-dark">DEVICE DETAILS</p>
                        <p className="small text-dark">{brand} - {model} ({serialNumber})</p>
                    </div>
                    <div className="col-12 col-sm-12">
                        <div className="text-center ">
                            <img 
                                src={showSuccess ? "deviceenroll.svg" : 'https://chola-qr.s3.ap-south-1.amazonaws.com/hfinpingme_setup_11122025.png'} 
                                alt="" 
                                onClick={() => { setShowModal(true) }} 
                                className={showSuccess ? "img-fluid" : "img-fluid dotted"} 
                            />
                        </div>
                    </div>
                    <div className="col-5 col-sm-5">
                        <p className="small m-0 text-start">
                            <span className='blue'>Application ID:</span>
                            <p className="fw-normal small text-dark fw-semibold">{application_id}</p>
                        </p>
                    </div>
                    <div className="col-7 col-sm-7 text-end">
                        <p className="small m-0">
                            <span className='blue'>Message:</span>
                            <p className="fw-normal small text-dark fw-semibold">{showSuccess ? `Device is enrolled` : `Device is not enrolled`}</p>
                        </p>
                    </div>
                </div>
                <div className="row gy-3 mt-2">
                    <div className="overall-pwer col-12">
                        <ImageComponent fileName="wifi2.svg" className="img-fluid" alt="wifi" />
                        <div className="poweron">
                            <p className="power-txt text-dark text-start">Unbox the new Device</p>
                            <p className="small">Power on, connect to Wi-Fi</p>
                        </div>
                    </div>
                    <div className="overall-pwer">
                        <ImageComponent fileName="TAP.svg" className="img-fluid" alt="tap" />
                        <div className="poweron">
                            <p className="power-txt text-dark text-start">Tap to open scanner</p>
                            <p className="small">Tap screen 6 to 7 times to reveal QR scanner</p>
                        </div>
                    </div>
                    <div className="overall-pwer">
                        <ImageComponent fileName="SCAN.svg" className="img-fluid" alt="scan" />
                        <div className="poweron">
                            <p className="power-txt text-dark text-start">Scan & Setup
                            </p>
                            <p className="small">Scan QR code, follow on-screen steps</p>
                        </div>
                    </div>
                    <div className="overall-pwer">
                        <ImageComponent fileName="BROSTICK.svg" className="img-fluid" alt="brostick" />
                        <div className="poweron">
                            <p className="power-txt text-dark text-start">Ready to Use
                            </p>
                            <p className="small">Setup complete, new device is ready</p>
                        </div>
                    </div>
                    <button
                        className='border-0 bg-transparent w-100'
                        onClick={handleRetrieveClick}
                        disabled={isDisabled}
                    >
                        <div className="overall-pwer">

                            <ImageComponent fileName="BROLINK.svg" className="img-fluid" alt="brolink" />
                            <div className="poweron">
                                <p className="power-txt text-start">Check Status
                                </p>
                                <p className="small">click here</p>
                            </div>

                        </div>
                    </button>
                    {isDisabled && (
                        <p className='mt-2 small fw-normal text-dark text-start'>
                            You can retry in {secondsLeft} second{secondsLeft !== 1 ? 's' : ''}.
                        </p>
                    )}
                </div>
            </div>

            <Modal
                id="qrmodal"
                show={showModal}
                onClose={() => setShowModal(false)}
                modalClass="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal custom-modal"
            >
                <ModalHeader>
                    <div className="top-draw"></div>
                </ModalHeader>
                <ModalBody className="text-center">

                    <img
                        src={showSuccess ? "deviceenroll.svg" : 'https://chola-qr.s3.ap-south-1.amazonaws.com/hfinpingme_setup_11122025.png'}
                        alt="Preview"
                        className="img-fluid"
                    />
                </ModalBody>
            </Modal>
        </>
    )
}

export default Screenbros